// extracted by mini-css-extract-plugin
module.exports = {"container":"About_container__h5LwU","content":"About_content__3clsp","text":"About_text__1r4zY"};